import React from 'react'

const GalleryNoItems = () => <div className="gallery-no-items">No images loaded yet</div>

export default GalleryNoItems
